import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { UpdateStudentSettingsBody } from "@shared-kernel/application/ports/admin/admin-repository";

export interface UpdateStudentSettingsParams {
  studentId: string;
  body: UpdateStudentSettingsBody;
}

export const updateStudentSettings = createAsyncThunk<string, UpdateStudentSettingsParams, { extra: Partial<Dependencies> }>(
  "admin/students/updateSettings",
  async ({ studentId, body }, { extra: { adminRepository } }) => {
    await adminRepository!.updateStudentSettings(studentId, body);
    return studentId;
  },
);

export const resetUpdateStudentSettings = createAction("admin/students/resetUpdateSettings");
